<template>
    <v-row>
        <v-col :xs="12">
            <v-card>
                <v-card-title>
                    Items
                    <v-spacer></v-spacer>
                    <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Search"
                            single-line
                            hide-details
                    ></v-text-field>
                    <v-spacer></v-spacer>
                    <v-btn @click="sendReplaceWarehouseStockRequest">Import Warehouse Stock</v-btn>
                </v-card-title>
                <v-data-table
                        :headers="headers"
                        :items="items"
                        :options.sync="options"
                        :server-items-length="totalItems"
                        :loading="loading"
                        :footer-props="footerProps"
                        :dense="dense"
                        class="elevation-1"
                >
                    <template v-slot:item.editButton="{ item }">
                        <v-btn :to="{name: 'item-details', params: {id: item.id}}" dark x-small>Edit</v-btn>
                    </template>
                </v-data-table>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
  const axios = require('axios')
  import {getCookie} from '@/helpers/getCookie.js'
  import {getFormattedDate} from '@/helpers/dateFormatters.js'

  export default {
    name: "ItemsList",
    data() {
      return {
        footerProps: {
          "itemsPerPageOptions": [25, 50, 100, 10000]
        },
        dense: true,
        search: "",
        totalItems: 0,
        items: [],
        loading: true,
        options: {},
        headers: [
          {text: 'SKU', value: 'id'},
          {text: 'Name', value: 'name'},
          {text: 'Barcode', value: 'barcode'},
          {text: 'Total at warehouse', value: 'totalAtWarehouse'},
          {text: 'Available at warehouse', value: 'available'},
          {text: 'Reserved', value: 'reserved'},
          {text: 'Incoming stock', value: 'totalIncomingStock'},
          {text: 'Total w/ incoming stock', value: 'totalAtWarehousesAndIncludingIncomingStock'},
          {text: 'Available w/ incoming stock', value: 'availableIncludingIncomingStock'},
          {text: 'Incoming stock dates', value: 'incomingStocksDates'},
          {text: 'Edit', value: 'editButton', sortable: false}
        ],
      }
    },
    watch: {
      options: {
        handler() {
          this.getItemsFromApi()
            .then(data => {
              this.loading = false
              this.items = this.prepareItemsForList(data.items)
              this.totalItems = data.total
            })
        },
        deep: true,
      },
      search: {
        handler(){
          if (this.search === "" || this.search.length >= 2){
            console.log("searching")
            this.getItemsFromApi()
              .then(data => {
                this.loading = false
                this.items = this.prepareItemsForList(data.items)
                this.totalItems = data.total
              })
          }
        }
      },
    },
    methods: {
      prepareItemsForList(items) {
        var parsedItems = []
        for (var i = 0; i < items.length; i++) {
          var item = items[i]
          var incomingStockDates = "";
          for (var j = 0; j < item.incoming_stocks.length; j++) {
            var date = getFormattedDate(item.incoming_stocks[j].date);
            var quantity = item.incoming_stocks[j].quantity;
            incomingStockDates += date + " (Qty:"+ quantity + ")\n"
          }

          var parsedItem = {
            id: item.id,
            name: item.name,
            barcode: item.barcode,
            totalAtWarehouse: item.total_at_warehouses, //item.delivery_address.name,
            available: item.available,
            reserved: item.reserved,
            totalIncomingStock: item.total_incoming_stock,
            totalAtWarehousesAndIncludingIncomingStock: item.total_at_warehouses_and_including_incoming_stock,
            availableIncludingIncomingStock: item.available_including_incoming_stock,
            incomingStocksDates: incomingStockDates,
          }
          parsedItems.push(parsedItem)
        }
        return parsedItems
      },
      getItemsFromApi() {
        this.loading = true
        return new Promise((resolve) => {
            //const {sortBy, sortDesc, page, itemsPerPage} = this.options
            var redirectToLoginFunction = this.redirectToLogin
            var limit = this.options.itemsPerPage
            var offset = (this.options.page - 1) * this.options.itemsPerPage
            var params = {
              limit: limit,
              offset: offset
            }

            if (this.search.length >= 2){
              params.search = this.search
            }

            axios.get("/api/items/", {
              params: params,
              headers: {
                Authorization: "Token " + this.$store.getters.authToken
              }
            }).then(function (response) {
              var total = response.data.count
              var items = response.data.results
              resolve({
                  items,
                  total,
                }
              )
            }).catch(function (error) {
              if (403 === error.response.status) {
                alert("Failed to obtain data")
                redirectToLoginFunction()
              }
            })
          }
        )
      },
      redirectToLogin() {
        this.$router.push({name: 'login'})
      },
      sendReplaceWarehouseStockRequest() {
        var redirectToLoginFunction = this.redirectToLogin
        axios.post("/api/replace_stock_from_pvx/", {}, {
          headers: {
            "X-CSRFToken": getCookie("csrftoken")
          }
        }).then(function () {
          alert("Import request successfully sent")
        }).catch(function (error) {
          if (403 === error.response.status) {
            alert("Failed to send request, login required")
            redirectToLoginFunction()
          }
          else {
            console.log(error)
            alert("Failed to send request, check console for details")
          }
        })
      }
    },
  }
</script>

<style scoped>

</style>